import { Injectable } from "@angular/core";
import {  environmentPingId ,pingIdToken } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APISchedulerService {
    ApiURL: string = "";
    constructor(private http: HttpClient, public helperService: HelperService) {
        this.ApiURL =  environmentPingId.PingIdvehicleDataUrl + 'schedule/';
    }

    public get(id?: string): Observable<any>{
         const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
                const requestOptions = {
                    headers: headers,
                };
                 const body: any = {
                        ScheduleId: Number(id),
                        };
               
                return this.http.post<any >(this.ApiURL+"info",body,requestOptions) 
    }

    public postDataScheduler(data): Observable<any> {
          const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
        const requestOptions = {
          headers: headers,
        };

        return this.http.post<any>(this.ApiURL+"create", data, requestOptions)
    }

    public put(data): Observable<any> {
       const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
        const requestOptions = {
          headers: headers,
        };

        return this.http.post<any>(this.ApiURL+"update/partial", data, requestOptions)
    }
}
